import React, { useContext, useEffect, useState } from 'react';
import acm from './AddCarModal.module.css'
import Plus from "../../../../assets/Icon/Plus";
import AddClientForm from './ClientForm/ClientForm'
import AddCarForm from './CarForm/CarForm'
import AddCompanyForm from './CompanyForm/CompanyForm'
import TransportForm from './TransportForm/TransportForm'
import ClientPriceForm from './ClientPriceForm/ClientPriceForm'
import CompanyPriceForm from './CompanyPriceForm/CompanyPriceForm'
import SalerPriceForm from './SalerPriceForm/SalerPriceForm';
import { AppContext } from '../../../../providers/appProvider';
import { useCar } from '../../../../hooks/useCar';
import { useNavigate } from 'react-router-dom';
import { DEPOSIT_WEBSITE_ID, INSPECTION_WEBSITE_ID } from '../../../../utils/constans';
import { validatePhoneNumber } from '../../../../utils/phone';
import { useTranslation } from 'react-i18next';

const CarForm = ({ id, isAdd }) => {
    const { t } = useTranslation();
    
    let navigate = useNavigate();
    const { carService } = useCar(-1);
    const [newCar, setNewCar] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const [isFirstValidated, setIsFirstValidated] = useState(false)

    const [validates, setValidates] = useState({})
    const { appState, app } = useContext(AppContext);

    const validateCar = (car) => {
        const messages = {};

        if (car.purchased_at.length < 5) {
            messages.purchased_at = { message: 'სავალდებულოა', isValid: false };
        }

        if (car.client_id === 0 ) {
            if (car.dealer_id === 0 ) {

                if (!car.client.firstname || car.client.firstname.length < 2) {
                    messages.firstname = { message: 'მიუთითეთ სახელი', isValid: false };
                }


                if (!car.client.lastname || car.client.lastname.length < 2) {
                    messages.lastname = { message: 'მიუთითეთ გვარი', isValid: false };
                }


                const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

                if (!car.client.email || car.client.email.length < 2 || !emailRegex.test(car.client.email)) {
                    messages.email = { message: 'ელ-ფოსტა არასწორია', isValid: false };
                }
    
                if (!car.client.mobile || !validatePhoneNumber(car.client.mobile)) {                
                    messages.mobile = { message: 'ნომერი არასწორია', isValid: false };
                }  
            } 
        } 

        if (car.website_id !== DEPOSIT_WEBSITE_ID) {
            if (car.maker_id < 1) {
                messages.maker_id = { message: 'სავალდებულოა', isValid: false };
            }

            if (car.model_id < 1) {
                messages.model_id = { message: 'სავალდებულოა', isValid: false };
            }

            if (car.vin.length != 17) {
                messages.vin = { message: 'საჭროა 17 სიმბოლო', isValid: false };
            }

            if (car.lot.length < 2) {
                messages.lot = { message: 'სავალდებულოა', isValid: false };
            }

            if (car.prod_year < 1919) {
                messages.prod_year = { message: 'აირჩიე წელი', isValid: false };
            }

            if (car.service != 5 && car.service != 3 && car.transport_price_id < 1) {
                messages.transport_price_id = { message: 'სავალდებულოა', isValid: false };
            }

            if (car.insurance < 1) {
                messages.insurance = { message: 'სავალდებულოა', isValid: false };
            }

            if (car.service != 5 && car.service != 3 && car.reciever_country_id < 1) {
                    messages.reciever_country_id = { message: 'სავალდებულოა', isValid: false };
            }

            if (car.service != 5 && car.service != 3 && car.reciever_city_id < 1) {
                messages.reciever_city_id = { message: 'სავალდებულოა', isValid: false };
            }

           
        }


        if ((isAdd || car.website_id !== DEPOSIT_WEBSITE_ID) && car.source_id < 1) {
            messages.source_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (car.website_id < 1) {
            messages.website_id = { message: 'სავალდებულოა', isValid: false };
        }


        if (car.saler_id < 1 && app.hasPermission("ADD_FINANCE_SUPER")) {
            messages.saler_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (car.dealer_id == null && car.service != 3) {
            messages.dealer_id = { message: 'სავალდებულოა', isValid: false };
        }

        if (car.status_id < 1) {
            messages.status_id = { message: 'სავალდებულოა', isValid: false };
        }


        if (car.searchedClients == 1) {
            messages.searchedClients = { message: 'აირჩიე ჩომოთვლილი კლიენტები', isValid: false };
        }



        const isValid = Object.keys(messages).length === 0;
        setValidates(messages)
        return isValid;
    };

    useEffect(() => {
        if (isFirstValidated === true) {
            if (newCar) {
                const isValidate = validateCar(newCar)
            }
        }
    }, [newCar, isFirstValidated]);

    useEffect(() => {
        if (isAdd === true) {
            setNewCar(carService.initData(null))
        } else {
            carService.getCarById(Number(id))
                .then(car => {
                    if (car) {
                        const editedCar = carService.initData(car)
                        setNewCar(editedCar)
                        setIsLoading(false);

                            if (!app.hasPermission("FINANCE_EDIT_IF_CAR_PRICE_0")) {
                                if (editedCar.client_price_car > 0 ) {
                                    app.setError("ამ ფინანსს არ აქვს რედაქტირების უფლება");
                                    navigate(-1);
                                }
                            }

                    } else {
                    }
                })
                .catch(error => {
                    console.error("Error fetching the car:", error);
                });
        }
    }, []);

    if (isLoading || !newCar) {
        return <div>Loading...</div>;
    }

    const prices = carService.calculatePrice(newCar);

    const operateHandle = () => {

        let isValidate = validateCar(newCar)

        if (newCar.dealer_id > 0) {
            if (prices.companyPrice > prices.clientPrice) {
                isValidate = false;
                app.setError("კლიენტის გადასახდელი ნაკლები არ უნდა იყოს კომპანიის გადასახდელისა");
            }
        } else {

 
            if(!app.hasPermission("CLIENT_PRICE_EDIT")) {
                if (newCar.discount_accept) {
 
                    if ((Number(newCar.client_price_discount + prices.clientPrice )) < Number(prices.salerPrice )) {
                        isValidate = false;
                        app.setError("სელერის გადასახდელი და კლიენტის ფასდაკლების ჯამი მეტია კლიენტის გადასახდელისა ") ;
                    }

                } else{
                    
                    if(prices.clientPrice < prices.salerPrice) {
                        isValidate = false;
                        app.setError("სელერის გადასახდელი მეტია კლიენტის გადასახდელისა");
                    }
                }


                if (newCar.client_price_transport < newCar.saler_price_transport) {
                    isValidate = false;
                    app.setError('კონტეინერის ფასი ნაკლებია კომპანიის მიერ გაცემულ ფასზე!');
                }
                if (newCar.client_price_document < newCar.saler_price_document) {
                    isValidate = false;
                    app.setError('საბუთის ღირებულება არასწორია!');
                }
                if ((newCar.client_price_document < newCar.car_price_document) || (newCar.saler_price_document < newCar.car_price_document)) {
                    isValidate = false;
                    app.setError('საბუთის ღირებულების შეცდომა!');
                }
                if (newCar.client_price_penalty < newCar.saler_price_penalty) {
                    isValidate = false;
                    app.setError('ჯარიმის თანხა არასწორია!');
                }
                if ((newCar.client_price_penalty < newCar.car_price_penalty) || (newCar.saler_price_penalty < newCar.car_price_penalty)) {
                    isValidate = false;
                    app.setError('ჯარიმის ღირებულების შეცდომა!');
                }
                if (newCar.client_price_another < newCar.saler_price_another) {
                    isValidate = false;
                    app.setError('სხვა ხარჯი არასწორია!');
                }
                if ((newCar.client_price_another < newCar.car_price_another) || (newCar.saler_price_another < newCar.car_price_another)) {
                    isValidate = false;
                    app.setError('სხვა ხარჯის ღირებულების შეცდომა!');
                }
                if ((newCar.client_price_inspection < newCar.car_price_inspection) || (newCar.saler_price_inspection < newCar.car_price_inspection)) {
                    isValidate = false;
                    app.setError('სხვა ხარჯის ღირებულების შეცდომა!');
                }
                if (newCar.client_price_fund !== newCar.saler_price_fund) {
                    isValidate = false;
                    app.setError('მოთხოვნილი თანხა არასწორია!');
                }
                if (newCar.client_price_internal < newCar.saler_price_internal) {
                    isValidate = false;
                    app.setError('შიდა გადაზიდვის ფასი არასწორია!');
                }
                if ((newCar.car_price_internal > newCar.saler_price_internal) || (newCar.car_price_internal > newCar.client_price_internal)) {
                    isValidate = false;
                    app.setError('შიდა გადაზიდვის ფასი არასწორია!');
                }
            }
    }

        if (isValidate === true) {
            var updatedCar = {}

            if (newCar.website_id === DEPOSIT_WEBSITE_ID || newCar.website_id === INSPECTION_WEBSITE_ID ) {
                updatedCar = carService.resetPrices(newCar)
            } else {
                updatedCar = {
                    ...newCar
                };
            }

            delete updatedCar.searchedClients;
            delete updatedCar.transport_price;

            const action = isAdd ? carService.addCar : carService.updateCarPage;
            const successMessage = isAdd ? "ავტომობილი წარმატებით დაემატა" : "ავტომობილი წარმატებით განახლდა";

            
            if (!newCar || typeof newCar !== 'object') {
                console.error('Error: Invalid car data');
                app.setError('შეცდომა: არასწორი ავტომობილის მონაცემები');
                return;
            }

 
            action(updatedCar)
                .then(data => {
                    app.setOk(successMessage);
                    navigate('/finances');
                })
                .catch(errorMessage => {
                    console.error('შეცდომა:', errorMessage);
                    if (errorMessage.includes("email")) {
                        app.setError("შეცდომა: ესეთი ელ-ფოსტით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("mobile")) {
                        app.setError("შეცდომა: ესეთი მობილურით უკვე არსებობს მომხმარებელი");
                    } else if (errorMessage.includes("unique vin")) {
                        app.setError("შეცდომა: ესეთი VIN უკვე არსებობს");
                    } else {
                        app.setError("შეცდომა: " + errorMessage);
                    }
                });

        } else {
            setIsFirstValidated(true)
        }
    };

    return (
        <div>

            <div className={acm.modalHead} >
                <h3>
                    {isAdd ? (
                        <>
                            <span className={acm.iconHead}><Plus /></span> {t('AddFinance')}
                        </>
                    ) : (
                        <>
                            <span className={acm.iconHead}><Plus /></span> {t('EditFinance')} 
                        </>
                    )}

                </h3>
            </div>

            <div className={acm.head3item}>
                <div className={acm.cols}>
                    <AddCarForm newCar={newCar} setNewCar={setNewCar} validates={validates} isAdd={isAdd}></AddCarForm>
                </div>

                <div className={acm.cols}>
                    <AddCompanyForm newCar={newCar} setNewCar={setNewCar} validates={validates} isAdd={isAdd}> </AddCompanyForm>
                    <AddClientForm newCar={newCar} setNewCar={setNewCar} validates={validates} >  </AddClientForm>
                </div>

                <div className={acm.cols}>
                    <TransportForm newCar={newCar} setNewCar={setNewCar} validates={validates}></TransportForm>
                </div>

            </div>
            {newCar.website_id !== DEPOSIT_WEBSITE_ID &&

                <div className={acm.head3item} style={{ marginTop: "30px", }}>

                    {app.hasPermission("CLIENT_PRICE_SHOW") &&
                        <div className={acm.cols}>
                            <ClientPriceForm newCar={newCar} setNewCar={setNewCar} isAdd={isAdd} prices={prices} ></ClientPriceForm>
                        </div>
                    }


                    {app.hasPermission("SALER_PRICE_SHOW") &&
                        <div className={acm.cols}>
                            <SalerPriceForm newCar={newCar} setNewCar={setNewCar} isAdd={isAdd} prices={prices} ></SalerPriceForm>
                        </div>
                    }


                    {app.hasPermission("COMPANY_PRICE_SHOW") &&
                        <div className={acm.cols}>
                            <CompanyPriceForm newCar={newCar} setNewCar={setNewCar} isAdd={isAdd} prices={prices} ></CompanyPriceForm>
                        </div>
                    }


                </div>
            }
            <span onClick={operateHandle} style={{ marginLeft: 'auto' }} className={acm.btnPrimary}>{t('Save')}</span>

        </div>
    );
};

export default CarForm;
